/**
 * @file   src\components\AgentDashboard\ActionDropdown.js
 * @brief  This file is responsible for dropdown actions in dashboard
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { Dropdown } from "react-bootstrap";
import React from "react";
import TableMoreIconVertical from "../../images/table-more-vertical-icon.svg";
import {
  REPORT_MIN_MATCHES,
  isReportUnlocked,
  matchesUntilUnlock,
} from "../../pages/ActiveBuyerReport/reportGate";
const ActionDropdown = (props) => {
  const {
    onItemEdit,
    onItemDelete,
    editText,
    deleteText,
    itemId,
    disableEdit,
    buyerListLinkText,
    showBuyerListingFormUrl,
    client_Want_ad_Id,
    hideEdit,
    onChangeStatus,
    currentStatus,
    onGenerateReport,
    generateReportText,
    reportMatchCount,
    show,
    onToggle,
    onAssignClient,
    assignClientText,
    // GTCH-853: this want-listing's market posts through the BLS.
    isMarketRestricted = false,
  } = props;

  const showStatusActions = typeof onChangeStatus === "function";
  const status = (currentStatus || "ACTIVE").toUpperCase();
  return (
    <Dropdown show={show} onToggle={onToggle}>
      <Dropdown.Toggle variant="" id="dropdown-basic1111">
        <img src={TableMoreIconVertical} />
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        {!hideEdit ? (
          disableEdit ? (
            <Dropdown.Item
              onClick={() => showBuyerListingFormUrl(client_Want_ad_Id)}
            >
              {buyerListLinkText}
            </Dropdown.Item>
          ) : (
            <Dropdown.Item onClick={() => onItemEdit(itemId)}>
              {editText}
            </Dropdown.Item>
          )
        ) : (
          <></>
        )}
        {typeof onAssignClient === "function" && (
          <Dropdown.Item onClick={() => onAssignClient(itemId)}>
            {assignClientText || "Assign client"}
          </Dropdown.Item>
        )}
        {showStatusActions && status === "ACTIVE" && (
          <>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "PENDING")}>
              Mark pending
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "CLOSED")}>
              Close out (purchased)
            </Dropdown.Item>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "ARCHIVED")}>
              Archive listing
            </Dropdown.Item>
          </>
        )}
        {showStatusActions && status === "PENDING" && (
          <>
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "CLOSED")}>
              Close out (purchased)
            </Dropdown.Item>
            {/* GTCH-853: no route back to ACTIVE where the market posts
                through the BLS. */}
            {!isMarketRestricted && (
              <Dropdown.Item onClick={() => onChangeStatus(itemId, "ACTIVE")}>
                Re-activate
              </Dropdown.Item>
            )}
          </>
        )}
        {showStatusActions &&
          (status === "CLOSED" || status === "ARCHIVED") &&
          !isMarketRestricted && (
            <Dropdown.Item onClick={() => onChangeStatus(itemId, "ACTIVE")}>
              Re-activate
            </Dropdown.Item>
          )}
        {typeof onGenerateReport === "function" &&
          isReportUnlocked(reportMatchCount) && (
            <Dropdown.Item onClick={() => onGenerateReport(itemId)}>
              {generateReportText || "Generate Active Buyer Report"}
            </Dropdown.Item>
          )}
        {typeof onGenerateReport === "function" &&
          !isReportUnlocked(reportMatchCount) && (
            <Dropdown.Item
              disabled
              title={`Unlocks at ${REPORT_MIN_MATCHES} buyer matches - ${matchesUntilUnlock(
                reportMatchCount
              )} to go`}
            >
              Active Buyer Report (coming soon)
            </Dropdown.Item>
          )}
        <Dropdown.Item onClick={() => onItemDelete(itemId)}>
          {deleteText}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};
export default ActionDropdown;
